"use client";

import { c as _c } from "react/compiler-runtime";
import UserCICStatus from "@/components/user/utils/user-cic-status/UserCICStatus";
import UserCICTypeIconWrapper from "@/components/user/utils/user-cic-type/UserCICTypeIconWrapper";
import type { ApiCicOverview } from "@/generated/models/ApiCicOverview";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { useMemo } from "react";
import OverlappingAvatars from "@/components/common/OverlappingAvatars";
const TOP_RATERS_COUNT = 5;
export default function UserPageIdentityHeaderCIC(t0) {
  const $ = _c(30);
  const {
    profile,
    cicOverview
  } = t0;
  const cicRating = cicOverview?.total_cic ?? profile.cic;
  const raterCount = cicOverview?.contributor_count ?? 0;
  cicOverview?.contributors.data;
  let t1;
  if ($[0] !== cicOverview?.contributors.data) {
    t1 = (cicOverview?.contributors.data ?? []).slice(0, TOP_RATERS_COUNT).map(_temp);
    $[0] = cicOverview?.contributors.data;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const avatarItems = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="tw-mb-2 tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">NIC</div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== cicRating) {
    t3 = formatNumberWithCommas(cicRating);
    $[3] = cicRating;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="tw-text-3xl tw-font-semibold tw-leading-none tw-tracking-tight tw-text-white">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== profile) {
    t5 = <span className="-tw-mt-0.5 tw-h-4 tw-w-4 tw-flex-shrink-0"><UserCICTypeIconWrapper profile={profile} /></span>;
    $[7] = profile;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== cicRating) {
    t6 = <UserCICStatus cic={cicRating} />;
    $[9] = cicRating;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <div className="tw-mt-2 tw-flex tw-items-center tw-gap-1.5 tw-text-sm tw-font-semibold tw-uppercase">{t5}{t6}</div>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <div className="tw-flex tw-flex-col tw-items-start">{t4}{t7}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== avatarItems) {
    t9 = avatarItems.length > 0 && <OverlappingAvatars items={avatarItems} size="md" maxCount={TOP_RATERS_COUNT} />;
    $[17] = avatarItems;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== raterCount) {
    t10 = formatNumberWithCommas(raterCount);
    $[19] = raterCount;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  const t11 = raterCount === 1 ? "rater" : "raters";
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <span className="tw-text-sm tw-font-normal tw-text-iron-400">{t10}{" "}{t11}</span>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t12 || $[25] !== t9) {
    t13 = <div className="tw-flex tw-shrink-0 tw-flex-col tw-items-end tw-gap-2.5">{t9}{t12}</div>;
    $[24] = t12;
    $[25] = t9;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13 || $[28] !== t8) {
    t14 = <div className="tw-mb-8">{t2}<div className="tw-mt-1 tw-flex tw-items-start tw-justify-between tw-gap-6">{t8}{t13}</div></div>;
    $[27] = t13;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
}
function _temp(c) {
  return {
    key: c.profile.handle ?? c.profile.primary_address,
    pfpUrl: c.profile.pfp ?? null,
    href: `/${c.profile.handle ?? c.profile.primary_address}`,
    ariaLabel: c.profile.handle ?? c.profile.primary_address,
    fallback: c.profile.handle ? c.profile.handle.charAt(0).toUpperCase() : "?",
    title: c.profile.handle ?? c.profile.primary_address,
    tooltipContent: <span>{c.profile.handle ?? c.profile.primary_address} ·{" "}{formatNumberWithCommas(c.contribution)}</span>
  };
}